export default __webpack_public_path__ + "static/media/640_dummy2016-sprachunterricht01-mobile-de.80ed4871.png";